import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { EmailService } from '../../shared/services/email.service';

interface FaqItem {
  question: string;
  answer: string;
  open: boolean;
}

interface ContactForm {
  name: string;
  email: string;
  subject: string;
  message: string;
}

@Component({
  selector: 'app-contact',
  standalone: true,
  imports: [CommonModule, RouterModule, FormsModule],
  templateUrl: './contact.html',
  styleUrl: './contact.scss'
})
export class Contact {

  private http = inject(HttpClient);
  private emailService = inject(EmailService);

  // ── Form state ──────────────────────────────────────────────────────────
  form: ContactForm = { name: '', email: '', subject: '', message: '' };

  subjects = [
    'Question générale',
    'Problème technique',
    'Référencer mon activité',
    'Signaler un contenu',
    'Partenariat',
    'Autre'
  ];

  isLoading = false;
  submitStatus: 'idle' | 'success' | 'error' = 'idle';

  onSubmit(): void {
    if (this.isLoading) return;
    this.isLoading = true;
    this.submitStatus = 'idle';

    const body = this.form.name + ' (' + this.form.email + ') vous a envoyé ce message via la page de contact de Referio :\n\n' + this.form.message;


    this.emailService.sendEmail({
      from: 'info@referio.be',
      to: 'contact@referio.be',
      subject: this.form.subject,
      text: body
    }).subscribe({
      next: () => {
        this.submitStatus = 'success';
        this.isLoading = false;
        this.form = { name: '', email: '', subject: '', message: '' };
      },
      error: () => {
        this.submitStatus = 'error';
        this.isLoading = false;
      }
    });
  }

  // ── Contact info ────────────────────────────────────────────────────────
  contactEmail = 'contact@referio.be';

  hours = [
    { day: 'Lundi – Vendredi', time: '9h00 – 18h00', active: true },
    { day: 'Samedi', time: '10h00 – 14h00', active: true },
    { day: 'Dimanche', time: 'Fermé', active: false },
  ];

  // ── FAQ ─────────────────────────────────────────────────────────────────
  faqs: FaqItem[] = [
    {
      question: 'Comment référencer mon activité sur Referio ?',
      answer: 'Il vous suffit de créer un compte professionnel en cliquant sur "Référencer mon activité" depuis la page d\'accueil.',
      open: false
    },
    {
      question: 'Est-ce que Referio est gratuit ?',
      answer: 'Oui, l\'inscription et l\'utilisation de base sont entièrement gratuites. Des options pour les professionnels et premium sont disponibles permetant de référencer une entreprise et d\'accéder à des fonctionnalités avancées.',
      open: false
    },
    {
      question: 'Comment modifier les informations de mon entreprise ?',
      answer: 'Connectez-vous à votre tableau de bord, puis rendez-vous dans "Mes sociétés". Vous pouvez y modifier toutes vos informations (description, photos, coordonnées...) à tout moment.',
      open: false
    },
    {
      question: 'Comment signaler un profil incorrect ou frauduleux ?',
      answer: 'Vous pouvez nous contacter directement via ce formulaire en choisissant le sujet "Signaler un contenu".',
      open: false
    },
    {
      question: 'Dans quel délai vais-je recevoir une réponse ?',
      answer: 'Notre équipe répond à toutes les demandes dans un délai de 24 à 48 heures ouvrables. Pour les questions urgentes, n\'hésitez pas à nous écrire directement par email.',
      open: false
    },
    {
      question: 'Comment supprimer mon compte ?',
      answer: 'Vous pouvez supprimer votre compte depuis les paramètres de votre profil, rubrique "Compte". La suppression est définitive et entraîne l\'effacement de toutes vos données conformément au RGPD.',
      open: false
    }
  ];

  toggleFaq(index: number): void {
    this.faqs[index].open = !this.faqs[index].open;
  }
}